<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/cohort")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.cohort") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-3.mb-1(v-if="filterBy == 'day'")
                  DateRangePicker(:value="dateRangeDay" @update="getData" ref="dateRangeDay")
                div.col-md-2.mb-1(v-if="filterBy == 'month'")
                  b-input-group(:prepend="$t('ui.start_date')" size="sm")
                    date-picker(v-model="dateRangeMonthStart" :config="localeMonth")
                div.col-md-2.mb-1(v-if="filterBy == 'month'")
                  b-input-group(:prepend="$t('ui.end_date')" size="sm")
                    date-picker(v-model="dateRangeMonthEnd" :config="localeMonth")
                div.col-md-2.mb-1(v-if="filterBy == 'year'")
                  b-input-group(:prepend="$t('ui.start_date')" size="sm")
                    date-picker(v-model="dateRangeYearStart" :config="localeYear")
                div.col-md-2.mb-1(v-if="filterBy == 'year'")
                  b-input-group(:prepend="$t('ui.end_date')" size="sm")
                    date-picker(v-model="dateRangeYearEnd" :config="localeYear")
                div.col-md-2.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                      @input="onChangeFilter()"
                    )
                      b-form-radio(value="day") {{ $tc("ui.day",1) }}
                      b-form-radio(value="month") {{ $t("ui.month") }}
                      b-form-radio(value="year") {{ $tc("ui.year",1) }}
                div.col-md-3.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getListing()"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div.mb-1(v-if="pageLvl == 'detail'")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToSummaryLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize(v-if="pageLvl == 'summary'")
            div.col-md-12(v-if="filterBy == 'day' && dayList.length > 0")
              .clusterize-scroll(style="max-width:85vw !important;")
                table.tablex#tblList(style="width: auto;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(style="width: 80px !important;")
                        span(:title="$t('ui.cohort')") {{ $t('ui.cohort') }}
                      th.sticky-position(style="width: 60px !important;")
                        span(:title="$tc('ui.users',2)") {{ $tc('ui.users',2) }}
                      template(v-for="index in dayRange + 1")
                        th.sticky-position(v-show="index - 1 <= dayRange" style="width: 58px !important;")
                          span(:title="$tc('ui.day', 1) + index - 1") {{ $tc('ui.day',1) }} {{ index - 1 }} (%)
                  tbody.clusterize-content
                    tr(v-if="dayList.length == 0")
                      td(:colspan="dayRange + 2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in dayList")
                      td
                        span(:title="$moment(item.cohort).format('YYYY-MM-DD')") {{ $moment(item.cohort).format('YYYY-MM-DD') }}
                      td
                        span(:title="item['0']") {{ item['0'] }}
                      template(v-for="index1 in dayRange + 1")
                        td
                          span(:title="parseFloat(item[index1 - 1])" v-if="item['p' + (index1 - 1)]")
                            b-link.clickable(href="javascript:void(0);" @click="setDay(item.cohort, index1)") {{ parseFloat(item['p' + (index1 - 1)]).toFixed(2) }}
                    tr(v-if="showTotalDay")
                      td.text-right
                        span {{ $t("ui.grand_total") }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(dayGrandTotal[0]['0'])" :title="$n(dayGrandTotal[0]['0'], 'integer')") {{ $n(dayGrandTotal[0]['0'], 'integer') }}
                      template(v-for="index1 in dayRange + 1")
                        td
                          span(:title="parseFloat(dayGrandTotal[0][index1 - 1])" v-if="dayGrandTotal[0]['p' + (index1 - 1)]") {{ parseFloat(dayGrandTotal[0]['p' + (index1 - 1)]).toFixed(2) }}
            div.col-md-12(v-if="filterBy == 'month' && monthList.length > 0")
              .clusterize-scroll(style="max-width:85vw !important;")
                table.tablex#tblList(style="width: auto;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(style="width: 80px !important;")
                        span(:title="$t('ui.cohort')") {{ $t('ui.cohort') }}
                      th.sticky-position(style="width: 60px !important;")
                        span(:title="$tc('ui.users',2)") {{ $tc('ui.users',2) }}
                      template(v-for="index in monthRange + 1")
                        th.sticky-position(v-show="index - 1 <= monthRange" style="width: 58px !important;")
                          span(:title="$t('ui.month') + index - 1") {{ $t('ui.month') }} {{ index - 1 }} (%)
                  tbody.clusterize-content
                    tr(v-if="monthList.length == 0")
                      td(:colspan="monthRange + 2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in monthList")
                      td
                        span(:title="$moment(item.cohort).format('YYYY-MM')") {{ $moment(item.cohort).format('YYYY-MM') }}
                      td
                        span(:title="item['0']") {{ item['0'] }}
                      template(v-for="index1 in monthRange + 1")
                        td
                          span(:title="parseFloat(item[index1 - 1])" v-if="item['p' + (index1 - 1)]")
                            b-link.clickable(href="javascript:void(0);" @click="setMonth(item.cohort, index1)") {{ parseFloat(item['p' + (index1 - 1)]).toFixed(2) }}
                    tr(v-if="showTotalMonth")
                      td.text-right
                        span {{ $t("ui.grand_total") }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(monthGrandTotal[0]['0'])" :title="$n(monthGrandTotal[0]['0'], 'integer')") {{ $n(monthGrandTotal[0]['0'], 'integer') }}
                      template(v-for="index1 in monthRange + 1")
                        td
                          span(:title="parseFloat(monthGrandTotal[0][index1 - 1])" v-if="monthGrandTotal[0]['p' + (index1 - 1)]") {{ parseFloat(monthGrandTotal[0]['p' + (index1 - 1)]).toFixed(2) }}
            div.col-md-12(v-if="filterBy == 'year' && yearList.length > 0")
              .clusterize-scroll(style="max-width:85vw !important;")
                table.tablex#tblList(style="width: auto;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(style="width: 80px !important;")
                        span(:title="$t('ui.cohort')") {{ $t('ui.cohort') }}
                      th.sticky-position(style="width: 60px !important;")
                        span(:title="$tc('ui.users',2)") {{ $tc('ui.users',2) }}
                      template(v-for="index in yearRange + 1")
                        th.sticky-position(v-show="index - 1 <= yearRange" style="width: 58px !important;")
                          span(:title="$tc('ui.year',1) + index - 1") {{ $tc('ui.year',1) }} {{ index - 1 }} (%)
                  tbody.clusterize-content
                    tr(v-if="yearList.length == 0")
                      td(:colspan="yearRange + 2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in yearList")
                      td
                        span(:title="item.cohort") {{ item.cohort }}
                      td
                        span(:title="item['0']") {{ item['0'] }}
                      template(v-for="index1 in yearRange + 1")
                        td
                          span(:title="parseFloat(item[index1 - 1])" v-if="item['p' + (index1 - 1)]")
                            b-link.clickable(href="javascript:void(0);" @click="setYear(item.cohort, index1)") {{ parseFloat(item['p' + (index1 - 1)]).toFixed(2) }}
                    tr(v-if="showTotalYear")
                      td.text-right
                        span {{ $t("ui.grand_total") }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(yearGrandTotal[0]['0'])" :title="$n(yearGrandTotal[0]['0'], 'integer')") {{ $n(yearGrandTotal[0]['0'], 'integer') }}
                      template(v-for="index1 in yearRange + 1")
                        td
                          span(:title="parseFloat(yearGrandTotal[0][index1 - 1])" v-if="yearGrandTotal[0]['p' + (index1 - 1)]") {{ parseFloat(yearGrandTotal[0]['p' + (index1 - 1)]).toFixed(2) }}
          div.row.clusterize(v-if="pageLvl == 'detail'")
            div.col-md-12(v-if="filterBy == 'day'")
              .clusterize-scroll(style="max-width:none !important;")
                table.tablex(style="width: 30%;")
                  thead
                    tr
                      th.sticky-position(width="20%")
                        span #
                      th.sticky-position(width="80%")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  tbody.clusterize-content
                    tr(v-if="dayDetailList.length == 0")
                      td(:colspan="2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in dayDetailList")
                      td
                        span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}
            div.col-md-12(v-if="filterBy == 'month'")
              .clusterize-scroll(style="max-width:none !important;")
                table.tablex(style="width: 30%;")
                  thead
                    tr
                      th.sticky-position(width="20%")
                        span #
                      th.sticky-position(width="80%")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  tbody.clusterize-content
                    tr(v-if="monthDetailList.length == 0")
                      td(:colspan="2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in monthDetailList")
                      td
                        span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}
            div.col-md-12(v-if="filterBy == 'year'")
              .clusterize-scroll(style="max-width:none !important;")
                table.tablex(style="width: 30%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position(width="10%")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  tbody.clusterize-content
                    tr(v-if="yearDetailList.length == 0")
                      td(:colspan="2").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in yearDetailList")
                      td
                        span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    dayList: [],
    monthList: [],
    yearList: [],
    dayGrandTotal: [],
    monthGrandTotal: [],
    yearGrandTotal: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    dateRangeDay: {
      startDate: null,
      endDate: null
    },
    filterBy: "day",
    dayRange: 0,
    monthRange: 0,
    yearRange: 0,
    dateRangeMonthStart: null,
    dateRangeMonthEnd: null,
    localeMonth: {
      format: "YYYY-MM",
      useCurrent: true,
      viewMode: "months"
    },
    dateRangeYearStart: null,
    dateRangeYearEnd: null,
    localeYear: {
      format: "YYYY",
      useCurrent: true,
      viewMode: "years"
    },
    showTotalDay: false,
    showTotalMonth: false,
    showTotalYear: false,
    pageLvl: "summary",
    dayDetailList: [],
    monthDetailList: [],
    yearDetailList: [],
    totalRow: 0,
    currentPage: 0,
    ftdDay: null,
    ftdMonth: null,
    ftdYear: null,

    sortType: "desc",
    addIndex: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.dateRangeDay.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRangeDay.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRangeMonthStart = this.$moment(new Date).format('YYYY-MM');
    this.dateRangeMonthEnd = this.$moment(new Date).format('YYYY-MM');
    this.dateRangeYearStart = this.$moment(new Date).format('YYYY');
    this.dateRangeYearEnd = this.$moment(new Date).format('YYYY');
  },
  methods: {
    onChangeFilter() {
      // if (this.filterBy == "day") {
      //   this.dateRangeDay.startDate = this.$moment(new Date).startOf("month").format('YYYY-MM-DD');
      //   this.dateRangeDay.endDate = this.$moment(new Date).endOf("month").format('YYYY-MM-DD');
      //   this.$refs.dateRangeDay.dateRangeDay.startDate = this.$moment(new Date).startOf("month").format('YYYY-MM-DD');
      //   this.$refs.dateRangeDay.dateRangeDay.endDate = this.$moment(new Date).endOf("month").format('YYYY-MM-DD');
      // }
    },
    checkDateRange() {
      if (this.filterBy == 'day') {
        if (this.$moment(this.dateRangeDay.endDate).diff(this.$moment(this.dateRangeDay.startDate), 'days') > 31)
          return false;
        else
          return true;
      } else if (this.filterBy == 'month') {
        if (this.$moment(this.dateRangeMonthEnd).diff(this.$moment(this.dateRangeMonthStart), 'months') > 31)
          return false;
        else
          return true;
      } else if (this.filterBy == 'year') {
        if (this.$moment(this.dateRangeYearEnd).diff(this.$moment(this.dateRangeYearStart), 'years') > 31)
          return false;
        else
          return true;
      }
    },
    getData(currentValue) {
      this.dateRangeDay.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeDay.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListing();
    },
    getListing() {
      if (this.filterBy == 'day')
        this.getCohortDay();
      else if (this.filterBy == 'month')
        this.getCohortMonth();
      else if (this.filterBy == 'year')
        this.getCohortYear();
    },
    getCohortDay: function() {
      if (this.checkDateRange()) {

        let url = config.cohortDayUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_date: this.dateRangeDay.startDate,
          end_date: this.dateRangeDay.endDate
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.showTotalDay = true;
                  this.ftdDay = this.dateRangeDay.startDate;
                  this.dayRange = this.$moment(this.dateRangeDay.endDate).diff(this.$moment(this.dateRangeDay.startDate), 'days');
                  this.dayList = response.data.ds.summary;
                  this.dayGrandTotal = response.data.ds.grand_total;
                } else {
                  this.dayList = [];
                  this.dayGrandTotal = [];
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.dayList = [];
        this.dayGrandTotal = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Days"), "error");
      }
    },
    getCohortMonth: function() {
      if (this.checkDateRange()) {

        let url = config.cohortMonthUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_date:  this.$moment(this.dateRangeMonthStart).startOf("month").format('YYYY-MM-DD'),
          end_date: this.$moment(this.dateRangeMonthEnd).startOf("month").format('YYYY-MM-DD'),
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summary.length > 0) {
                    this.showTotalMonth = true;
                    this.ftdMonth = this.dateRangeMonthStart;
                    this.monthRange = this.$moment(this.dateRangeMonthEnd).diff(this.$moment(this.dateRangeMonthStart), 'months');
                    this.monthList = response.data.ds.summary;
                    this.monthGrandTotal = response.data.ds.grand_total;
                  } else {
                    this.clearTotalMonth();
                  }
                } else {
                  this.clearTotalMonth();
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalMonth();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Months"), "error");
      }
    },
    getCohortYear: function() {
      if (this.checkDateRange()) {

        let url = config.cohortYearUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_year: this.$moment(this.dateRangeYearStart).format('YYYY'),
          end_year: this.$moment(this.dateRangeYearEnd).format('YYYY'),
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summary.length > 0) {
                    this.showTotalYear = true;
                    this.ftdYear = this.dateRangeYearStart;
                    this.yearRange = this.$moment(this.dateRangeYearEnd).diff(this.$moment(this.dateRangeYearStart), 'years');
                    this.yearList = response.data.ds.summary;
                    this.yearGrandTotal = response.data.ds.grand_total;
                  } else {
                    this.clearTotalYear()
                  }
                } else {
                  this.clearTotalYear()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalYear()
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Years"), "error");
      }
    },
    backToSummaryLvl() {
      this.pageLvl = "summary";
      this.clearDetail();
    },
    setDay: function (ftd, index) {
      this.ftdDay = ftd;
      this.addIndex = index - 1;
      this.totalRow = 0;
      this.dayDetailList = [];
      this.getCohortDayDetail(true);
    },
    setMonth: function (ftd, index) {
      this.ftdMonth = ftd;
      this.addIndex = index - 1;
      this.totalRow = 0;
      this.monthDetailList = [];
      this.getCohortMonthDetail(true);
    },
    setYear: function (ftd, index) {
      this.ftdYear = ftd;
      this.addIndex = index - 1;
      this.totalRow = 0;
      this.yearDetailList = [];
      this.getCohortYearDetail(true);
    },
    getCohortDayDetail: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.cohortDayDetailUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          ftd_date: this.$moment(this.ftdDay).format('YYYY-MM-DD'),
          target_date: this.$moment(this.ftdDay).add(this.addIndex, 'days').format('YYYY-MM-DD'),
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.pageLvl = 'detail';
                  this.dayDetailList = response.data.dt;
                  this.totalRow = response.data.dt.length > 0 ? this.dayDetailList[0]["totalrows"] : 0
                } else {
                  this.dayDetailList = [];
                  this.totalRow = 0;
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.dayDetailList = [];
        this.totalRow = 0;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Days"), "error");
      }
    },
    getCohortMonthDetail: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.cohortMonthDetailUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          ftd_date: this.$moment(this.ftdMonth).startOf("month").format('YYYY-MM-DD'),
          target_date: this.$moment(this.ftdMonth).startOf("month").add(this.addIndex, 'months').format('YYYY-MM-DD'),
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.pageLvl = 'detail';
                  this.monthDetailList = response.data.dt;
                  this.totalRow = response.data.dt.length > 0 ? this.monthDetailList[0]["totalrows"] : 0
                } else {
                  this.monthDetailList = [];
                  this.totalRow = 0;
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.monthDetailList = [];
        this.totalRow = 0;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Days"), "error");
      }
    },
    getCohortYearDetail: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.cohortYearDetailUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          ftd_year: this.ftdYear,
          target_year: this.ftdYear + this.addIndex,
          // ftd_year: this.$moment(this.ftdYear).format('YYYY'),
          // target_year: this.$moment(this.ftdYear).add(this.addIndex, 'years').format('YYYY'),
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.pageLvl = 'detail';
                  this.yearDetailList = response.data.dt;
                  this.totalRow = response.data.dt.length > 0 ? this.yearDetailList[0]["totalrows"] : 0
                } else {
                  this.yearDetailList = [];
                  this.totalRow = 0;
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.yearDetailList = [];
        this.totalRow = 0;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow31Days"), "error");
      }
    },
    clearTotalDay() {
      this.showTotalDay = false
      this.dayList = []
      this.dayGrandTotal = []
      this.dayDetailList = []
      this.ftdDay = null
      this.totalRow = 0
      this.currentPage = 1
    },
    clearTotalMonth() {
      this.showTotalMonth = false
      this.monthList = []
      this.monthGrandTotal = []
      this.monthDetailList = []
      this.ftdMonth = null
      this.totalRow = 0
      this.currentPage = 1
    },
    clearTotalYear() {
      this.showTotalYear = false
      this.yearList = []
      this.yearGrandTotal = []
      this.yearDetailList = []
      this.ftdYear = null
      this.totalRow = 0
      this.currentPage = 1
    },
    clearDetail() {
      this.totalRow = 0
      this.dayDetailList = []
      this.monthDetailList = []
      this.yearDetailList = []
      this.addIndex = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentPage = 1;
      if (this.filterBy == 'day')
        this.getCohortDayDetail(true);
      else if (this.filterBy == 'month')
        this.getCohortMonthDetail(true);
      else if (this.filterBy == 'year')
        this.getCohortYearDetail(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      if (this.filterBy == 'day')
        this.getCohortDayDetail();
      else if (this.filterBy == 'month')
        this.getCohortMonthDetail();
      else if (this.filterBy == 'year')
        this.getCohortYearDetail();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>